<template>
  <form class="col-12 b-form b-dialog__form">
    <server-error class="mb-4" :error="error" />
    <CreatePaymentWidget @closeDialog="closeDialog" @savePayment="onSavePayment($event)"></CreatePaymentWidget>
  </form>
</template>

<script>
	import CreatePaymentWidget from "../../../../widgets/CreatePaymentWidget";

	export default {
		components: {
			CreatePaymentWidget,
		},
		data() {
			return {
				error: null,
			}
		},
		methods: {
			async onSavePayment(data) {
				try {
					this.error = null;
					let newPayment = await this.$store.dispatch('createPayment', Object.assign({}, data));
					this.$emit('createPayment', newPayment);
					this.closeDialog();
				} catch (e) {
					this.error = e;
				}
			},
			closeDialog() {
				this.$emit('closeDialog');
			}
		}
	}
</script>

